import {
  GET_INVESTOR_TYPE,
  GET_CURRENT_USER_DETAILS,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PASSWORD,
} from "./constants";

export function getInvestorType(payload) {
  return {
    type: GET_INVESTOR_TYPE,
    payload,
  };
}

export function getCurrentUserDetails(payload) {
  return {
    type: GET_CURRENT_USER_DETAILS,
    payload,
  };
}

export function updateUserProfile(payload, onSuccessCurrentUser) {
  return {
    type: UPDATE_USER_PROFILE,
    payload,
    onSuccessCurrentUser,
  };
}

export function updateUserPassword(payload, onSuccess) {
  return {
    type: UPDATE_USER_PASSWORD,
    payload,
    onSuccess,
  };
}
